/* eslint-disable import/no-cycle */
import {
  // eslint-disable-next-line max-len
  IConversationItemGroupList, IConversationItemDirectList, IConversations, IResponse, IConversationItemDirectId, IConversationItemGroupId, IData, IList, IMixedData,
} from '@/types/interfaces';
import ApiService from '@/services/ApiService';
import { MESSAGE_SHARED_ITEM_TYPES, SHARE_ACCESS, SORT_TYPE } from '@/types/enums';
import { ITEMS_ON_PAGE } from '@/types/consts';

export default class MessagesService {
  public static fetchConverations(): Promise<IResponse<IConversations<IConversationItemDirectList[]>>> {
    return ApiService.getAndReturnData('messaging/conversations');
  }

  public static fetchGroupConverations(): Promise<IResponse<IConversations<IConversationItemGroupList[]>>> {
    return ApiService.getAndReturnData('groupMessaging/conversations');
  }

  public static fetchLastConverations(): Promise<IResponse<IConversations<(IConversationItemGroupList | IConversationItemDirectList)[]>>> {
    return ApiService.getAndReturnData('messaging/lastConversations');
  }

  public static filterByUserAndGroupType(): Promise<any> {
    return ApiService.getAndReturnData('shares/targets-to-share');
  }

  public static fetchConversationById(userId: string, previousMessageTimestamp: string, pageSize: number)
  : Promise<IResponse<{conversation: IConversationItemDirectId}>> {
    return ApiService.getAndReturnData(`messaging/conversation/${userId}/${previousMessageTimestamp}/${pageSize}`);
  }

  public static fetchGroupConversationById(userId: string, previousMessageTimestamp: string, pageSize: number)
  : Promise<IResponse<{conversation: IConversationItemGroupId}>> {
    return ApiService.getAndReturnData(`groupMessaging/conversation/${userId}/${previousMessageTimestamp}/${pageSize}`);
  }

  // public static fetchGroupSharedItems(groupId: string, type: MESSAGE_SHARED_ITEM_TYPES): Promise<IResponse<{units: (IMedia[] | ICase[])}>> {
  //   return ApiService.getAndReturnData(`groupMessaging/shareUnits/${groupId}/${type}`);
  // }

  // eslint-disable-next-line max-len
  public static fetchGroupSharedItems(groupId: string, type: MESSAGE_SHARED_ITEM_TYPES, page = 0, searchTerm = ''): Promise<IResponse<IData<IList<IMixedData>>>> {
    const payload: any = {
      paging: { page, itemsOnPage: ITEMS_ON_PAGE },
      sort: [{ field: 'UPDATED', order: SORT_TYPE.DESC }],
      searchTerm,
      filters: [{ field: 'GROUP', value: groupId }],
    };

    switch (type) {
      case MESSAGE_SHARED_ITEM_TYPES.CASE_TYPE:
        payload.filters.push({ field: 'TYPE', value: 'CASE' });
        break;
      case MESSAGE_SHARED_ITEM_TYPES.FILE_TYPE:
        payload.filters.push({ field: 'TYPE', value: 'FILE' }, { field: 'EXACT_TYPE', value: 'FILE_FILE' });
        break;
      case MESSAGE_SHARED_ITEM_TYPES.PHOTO_TYPE:
        payload.filters.push({ field: 'TYPE', value: 'FILE' }, { field: 'EXACT_TYPE', value: 'FILE_PHOTO' });
        break;
      default:
        break;
    }

    return ApiService.postAndReturnData('/mixed', payload);
  }

  public static async shareCaseInMessage(partnerId: string, caseId: string): Promise<IResponse> {
    const payload = {
      to: partnerId,
      content: 'Shared Case',
      share: {
        data: [
          {
            accessType: SHARE_ACCESS.SPECIFIC_PEOPLE,
            accessContent: [
              partnerId,
            ],
          },
        ],
        type: 'Case',
      },
    };
    return ApiService.postAndReturnData(`messaging/message?attachedUnitId=${caseId}`, payload);
  }

  public static joinToChat(chatId: string): Promise<any> {
    return ApiService.postAndReturnData(`messaging/joinToChat/${chatId}`);
  }

  public static leftFromCurrentChat(): Promise<any> {
    return ApiService.postAndReturnData('messaging/leftFromCurrentChat');
  }
}
